import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { UtilService } from '../util/util.service';

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy {
  constructor(private _translateService: TranslateService, private readonly _title: Title, private _utilService: UtilService) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title) {
      this._translateService.get(title).subscribe((translatedTitle) => {
        this._title.setTitle(this._utilService.toTitleCase(translatedTitle));
      });
    }
  }
}
